<script setup lang="ts">
import type { ITableColumnsOptions } from '@modules/tables/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import AffiliateTrackersAddButton from '@modules/affiliate-trackers/components/AffiliateTrackersAddButton/AffiliateTrackersAddButton.vue';
import AffiliateTrackersEditButton from '@modules/affiliate-trackers/components/AffiliateTrackersEditButton/AffiliateTrackersEditButton.vue';
import {
  AFFILIATE_TRACKERS_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATE_TRACKERS,
} from '@modules/affiliate-trackers/constants';
import { useAffiliateTrackersListQuery } from '@modules/affiliate-trackers/queries';
import { AFFILIATE_TRACKERS_CONDITION_ROUTE_NAME } from '@modules/affiliate-trackers/submodules/condition/constants';
import {
  AFFILIATE_TRACKERS_CREATIVES_ROUTE_NAME,
} from '@modules/affiliate-trackers/submodules/creatives/constants';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const {
  tableState,
  isLoading,
  isFetching,
  data,
  updateTableState,
  refreshTableData,
} = useTableData(useAffiliateTrackersListQuery);

const columnOptions: ITableColumnsOptions = {
  type_of_transaction: {
    localization: {
      translationPath: 'admin.partnership_program.conditions.create_edit.main_params.form.',
    },
  },
  tracker_code: {
    defaultMobilePreview: true,
  },
};
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateTrackersListPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_GROUP_AFFILIATE_TRACKERS, 'HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VButton
          :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_TRACKERS, 'DEALS_BUTTON')"
          text
          :to="{
            name: AFFILIATE_TRACKERS_CONDITION_ROUTE_NAME,
            params: {
              id: listItem.id,
            },
          }"
        />
        <VIconButton
          v-if="$hasPermission(AFFILIATE_TRACKERS_PERMISSIONS.SHOW_CREATIVE)"
          icon="pi-link"
          :to="{
            name: AFFILIATE_TRACKERS_CREATIVES_ROUTE_NAME,
            params: {
              id: listItem.tracker_code,
              type: 'list',
            },
          }"
        />
        <AffiliateTrackersEditButton
          v-if="$hasPermission(AFFILIATE_TRACKERS_PERMISSIONS.EDIT)"
          :item="listItem"
        />
      </template>
      <template
        #footerButtons
      >
        <div class="flex items-center gap-4">
          <AffiliateTrackersAddButton
            :disabled="!$hasPermission(AFFILIATE_TRACKERS_PERMISSIONS.CREATE) || !data?.available_trackers"
          />
          <span class="text-muted-color">
            {{ $getTranslation(TRANSLATION_GROUP_AFFILIATE_TRACKERS, 'AVAILABLE_TRACKER') }}
            <strong class="font-medium text-black">
              {{ data?.available_trackers }}
            </strong>
          </span>
        </div>
      </template>
    </VTable>
  </VCard>
</template>
